import { API_FETCH_SETTINGS, API_UPDATE_SETTING } from "@/config/api.config";
import apiCall from "@/utils/api";

export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const UPDATE_SETTING = "UPDATE_SETTING";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_SETTING_VALUE = "SET_SETTING_VALUE";

export default {
  [FETCH_SETTINGS]({ commit }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return apiCall({ method: API_FETCH_SETTINGS })
      .then(({ status, data }) => {
        if (status === 200 && data.result) {
          commit(SET_SETTINGS, data.data);
          return data.data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  [UPDATE_SETTING]({ commit }, { key, value, description }) {
    commit("SET_SAVING", true);
    commit("SET_ERROR", null);

    return apiCall({
      method: API_UPDATE_SETTING,
      parts: { key },
      data: { value, description },
    })
      .then(({ status, data }) => {
        if (status === 200 && data.result) {
          commit(SET_SETTING_VALUE, { key, value, description });
          return data.data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_SAVING", false);
      });
  },
};
